import React, { FC } from 'react';
import { Box, useTheme, Divider } from '@mui/material';
import { Typography, Button } from '@fdha/web-ui-library';
import { useChooseMealsData } from '@fdha/common-hooks';

import { getStyles } from './ChooseMealsFooter.styles';

interface ChooseMealsFooterProps {
  handleReviewSelection: () => void;
}

const ChooseMealsFooter: FC<ChooseMealsFooterProps> = ({
  handleReviewSelection,
}) => {
  const theme = useTheme();
  const styles = getStyles(theme);

  const { entreeDisplay, snacksDisplay } = useChooseMealsData();

  return (
    <>
      <Divider />
      <Box sx={styles.container}>
        <Box>
          <Typography
            variant="body2"
            color="text.secondary"
            i18nKey="meals:chooseMeals.footer.selectionSummary"
            i18nComponents={{
              entreeCount: (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontWeight: 'bold' }}
                  component="span"
                  i18nKey="meals:chooseMeals.footer.countNumbers"
                  i18nParams={{
                    selected: entreeDisplay.selected.toString(),
                    total: entreeDisplay.total.toString(),
                  }}
                >
                  {entreeDisplay.selected}/{entreeDisplay.total}
                </Typography>
              ),
              snacksCount: (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontWeight: 'bold' }}
                  component="span"
                  i18nKey="meals:chooseMeals.footer.countNumbers"
                  i18nParams={{
                    selected: snacksDisplay.selected.toString(),
                    total: snacksDisplay.total.toString(),
                  }}
                >
                  {snacksDisplay.selected}/{snacksDisplay.total}
                </Typography>
              ),
            }}
          >
            <strong>
              {entreeDisplay.selected}/{entreeDisplay.total}
            </strong>{' '}
            Entree dishes,{' '}
            <strong>
              {snacksDisplay.selected}/{snacksDisplay.total}
            </strong>{' '}
            Snacks/Sides
          </Typography>
        </Box>

        <Button
          variant="contained"
          onClick={handleReviewSelection}
          size="large"
          i18nKey="meals:chooseMeals.footer.reviewSelection"
        >
          Review Selection
        </Button>
      </Box>
    </>
  );
};

export default ChooseMealsFooter;
